import type { default as VideoJsPlayer } from 'video.js/dist/types/player';

// Full list of videojs events you can find here - https://gist.github.com/alexrqs/a6db03bade4dc405a61c63294a64f97a#file-videojs-plugin-events-logger-js-L5
type VideoJsEvent = 'playing' | 'waiting' | 'ended' | 'play' | 'pause';
export const VideoJsEvents: VideoJsEvent[] = ['playing', 'waiting', 'ended', 'play', 'pause'];

export type VideoJsPlayerStatus = (typeof VideoJsEvents)[number];

export interface VideoJsImaPlayer extends VideoJsPlayer {
	ima?: any;
}
